import './abritin3/style';
import FormStructure from './abritin3/form_structure';

export default FormStructure;